import {atom} from "recoil";
import {SelectElementModelFE} from "../api/types/generic";
import {FormSearchOWLocationGroupModel, OWLocationGroupEntityResponse} from "../api/types/owLocationGroup";

export const defaultSearchedOWLocationGroupLocation = {name: '', legalEntities: []}
export const searchedOWLocationGroupAtom = atom<FormSearchOWLocationGroupModel>({
    key: "searchedOWLocationGroupAtom",
    default: defaultSearchedOWLocationGroupLocation
});

export const owLocationGroupAtom = atom<SelectElementModelFE[]>({
    key: "owLocationGroupAtom",
    default: []
});

export const selectedOWLocationGroupAtom = atom<OWLocationGroupEntityResponse | null>({
    key: "selectedOWLocationGroupAtom",
    default: null
});